import React from "react";
import classes from "./styles/style.module.css";

const Statistics = ({ maxAnswer, duration, questionCount }) => {
  function millisecondsToMMSS(milliseconds) {
    let totalSeconds = Math.floor(milliseconds / 1000);
    let minutes = Math.floor(totalSeconds / 60);
    let seconds = totalSeconds % 60;
    let minutesStr = minutes.toString().padStart(2, "0");
    let secondsStr = seconds.toString().padStart(2, "0");

    return `${minutesStr}:${secondsStr}`;
  }

  return (
    <div className={classes.statisticsContainer}>
      <div className={classes.statisticsContent}>
        <h4>{maxAnswer}</h4>
        <p>قابل پاسخگویی</p>
      </div>
      <div className={`${classes.statisticsContent} ${classes.middle}`}>
        <h4>{millisecondsToMMSS(duration)}</h4>
        <p>زمان پاسخگویی</p>
      </div>
      <div className={classes.statisticsContent}>
        <h4>{questionCount}</h4>
        <p>تعداد سوالات آزمون</p>
      </div>
    </div>
  );
};

export default Statistics;
